import RendererKey from "./RendererKey"
class RendererKeyHelperStatic {
    getRendererKeys(): RendererKey[] {
        return [
            { service: "ign", keys: [ "cartes" ] }, //IGN now doesn't need a key, but its URL has 'cartes' in the place where the key used to be, so putting this here so the add logic stays the same, and in case it needs a key in future.
            { service: "mapbox", keys: [ "pk.eyJ1IjoiYmVudGF5bG9yIiwiYSI6Ik5WRF95TXcifQ.h24LeDgvQobB_uwKymYbTA" ] },
            { service: "os", keys: [ "Z2JlvRgqWdHm6l1yE3iTXTxO9qSNveER" ]}
        ]
    }
}

const RendererKeyHelper = new RendererKeyHelperStatic();
export default RendererKeyHelper;